import { FGTypography } from '@fg/design-system';
import React from 'react';

interface Props {
    label: string;
    color?: string;
}

const labelValueStyle = {
    textTransform: 'capitalize',
    color: 'var(--fg-color-text)',
    fontWeight: 600,
    marginBottom: '5px',
    fontSize: '13px',
};

export default class ExportChartChip extends React.Component<Props> {
    public render() {
        return (
            <div style={{ ...labelValueStyle, display: 'flex', alignItems: 'center' } }>
                {this.props.color && (
                    <span
                        style={{
                            width: '8px',
                            height: '8px',
                            marginRight: '5px',
                            backgroundColor: this.props.color,
                        }}></span>
                )}
                 <FGTypography variant="label2" tag="label">{this.props.label}</FGTypography>
            </div>
        );
    }
}
